import React, { useEffect } from "react";
import NonAuthLayout from "../../../layout/NonAuthLayout";
import Productindex from "../../../components/SideTab/Products";
import { Container, Row, Col } from "react-bootstrap";
import Productdetail from "../../../components/SideTab/Products/Productdetail";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { productDetails } from "../../../redux/states/products/thunk";
import { toast } from "react-toastify";

const ProductDetail = () => {
  const { slug, productId } = useParams();
  const dispatch = useDispatch();
  const product = useSelector((state) => state.products)?.productDetails;

  const getProductDetails = () => {
    dispatch(productDetails(slug))
      .unwrap()
      .then((response) => {})
      .catch((err) => {
        toast.error(err);
      });
  };

  useEffect(() => {
    getProductDetails();
  }, []);

  return (
    <>
      {/* <NonAuthLayout> */}
      <section className="Prodcut-section py-3">
        <Container fluid>
          <Productdetail data={product} />
        </Container>
      </section>
      {/* </NonAuthLayout> */}
    </>
  );
};

export default ProductDetail;
